/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { BarChartPreviewComponent } from '@app/app/shared/components/resource-preview/chart-preview/bar-chart/bar-chart-preview.component';
import { PolarChartPreviewComponent } from '@app/app/shared/components/resource-preview/chart-preview/polar-chart/polar-chart-preview.component';
import { RadarChartPreviewComponent } from '@app/app/shared/components/resource-preview/chart-preview/radar-chart/radar-chart-preview.component';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { TranslocoService } from '@ngneat/transloco';
import { SnackbarHelper } from '../../../helpers/snackbar-helper';
import { ChartContent } from '../../../models/editor/chart-content.model';

@Component({
  selector: 'ptl-chart-preview',
  templateUrl: './chart-preview.component.html',
  styleUrls: ['./chart-preview.component.scss'],
})
export class ChartPreviewComponent implements OnInit {
  /** Receives the Form object */
  @Input() chartContent: ChartContent;

  @Input() includeSelfFeedback: boolean;

  @ViewChild('chartComponent', { static: false }) chartComponent:
    | BarChartPreviewComponent
    | PolarChartPreviewComponent
    | RadarChartPreviewComponent;

  chartVersionStart: number;
  chartVersionEnd: number;

  constructor(
    private ngZone: NgZone,
    private snackBar: MatSnackBar,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    if (this.chartContent) {
      if (this.chartContent.versionedScores?.length) {
        this.chartContent.versionedScores = this.chartContent.versionedScores.sort((a, b) => {
          return +new Date(b.completedOn) - +new Date(a.completedOn);
        });
        this.chartVersionStart = this.chartContent.versionedScores[1]?.version;
        this.chartVersionEnd = this.chartContent.versionedScores[0]?.version;
      }
    }
  }

  applyDateFilter(): void {
    if (this.chartVersionStart === this.chartVersionEnd && this.chartContent?.chartType !== 'RADAR') {
      SnackbarHelper.showTranslatableSnackBar(
        this.ngZone,
        this.snackBar,
        this.translocoService,
        marker('translations.report.message.error.selectedDifferentDates'),
      );
      return;
    }

    if (this.chartContent.chartType === 'RADIAL') {
      (this.chartComponent as PolarChartPreviewComponent).updateChartDataByDates();
    } else if (this.chartContent.chartType === 'BAR') {
      (this.chartComponent as BarChartPreviewComponent).updateChartDataByDates();
    } else if (this.chartContent.chartType === 'RADAR') {
      (this.chartComponent as RadarChartPreviewComponent).updateChartDataByDates();
    }
  }
}
